import { render, staticRenderFns } from "./ContactBox.vue?vue&type=template&id=46bf09e0&scoped=true&"
import script from "./ContactBox.vue?vue&type=script&lang=ts&"
export * from "./ContactBox.vue?vue&type=script&lang=ts&"
import style0 from "./ContactBox.vue?vue&type=style&index=0&id=46bf09e0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bf09e0",
  null
  
)

export default component.exports